/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Desc_Shift_Event_BackwardInputs */

const en_shortcut_keys_desc_shift_event_backward = /** @type {(inputs: Shortcut_Keys_Desc_Shift_Event_BackwardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shift the selected event(s) backward by one frame`)
};

const fr_shortcut_keys_desc_shift_event_backward = /** @type {(inputs: Shortcut_Keys_Desc_Shift_Event_BackwardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Decaler les evenements selectionnes d'une image vers l'arriere`)
};

const de_shortcut_keys_desc_shift_event_backward = /** @type {(inputs: Shortcut_Keys_Desc_Shift_Event_BackwardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verschiebe das/die ausgewählte(n) Ereignis(se) um ein Frame nach hinten.`)
};

const it_shortcut_keys_desc_shift_event_backward = /** @type {(inputs: Shortcut_Keys_Desc_Shift_Event_BackwardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sposta indietro di un fotogramma gli eventi selezionati`)
};

const ru_shortcut_keys_desc_shift_event_backward = /** @type {(inputs: Shortcut_Keys_Desc_Shift_Event_BackwardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сдвинуть выбранное событие (события) назад на один кадр`)
};

const es_shortcut_keys_desc_shift_event_backward = /** @type {(inputs: Shortcut_Keys_Desc_Shift_Event_BackwardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desplazar el evento(s) seleccionado(s) hacia atrás un cuadro`)
};

const zh_cn2_shortcut_keys_desc_shift_event_backward = /** @type {(inputs: Shortcut_Keys_Desc_Shift_Event_BackwardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`将选定的事件向后移动一帧。`)
};

const ja_shortcut_keys_desc_shift_event_backward = /** @type {(inputs: Shortcut_Keys_Desc_Shift_Event_BackwardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`選択したイベントを1フレーム後ろにシフトします`)
};

const hi_shortcut_keys_desc_shift_event_backward = /** @type {(inputs: Shortcut_Keys_Desc_Shift_Event_BackwardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`चयनित घटना(ओं) को एक फ्रेम पीछे खिसकाएँ`)
};

const pt_pt2_shortcut_keys_desc_shift_event_backward = /** @type {(inputs: Shortcut_Keys_Desc_Shift_Event_BackwardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desloque o(s) evento(s) selecionado(s) para trás em um quadro.`)
};

/**
* | output |
* | --- |
* | "Shift the selected event(s) backward by one frame" |
*
* @param {Shortcut_Keys_Desc_Shift_Event_BackwardInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_desc_shift_event_backward = /** @type {((inputs?: Shortcut_Keys_Desc_Shift_Event_BackwardInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Desc_Shift_Event_BackwardInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortcut_keys_desc_shift_event_backward(inputs)
	if (locale === "de") return de_shortcut_keys_desc_shift_event_backward(inputs)
	if (locale === "it") return it_shortcut_keys_desc_shift_event_backward(inputs)
	if (locale === "ru") return ru_shortcut_keys_desc_shift_event_backward(inputs)
	if (locale === "es") return es_shortcut_keys_desc_shift_event_backward(inputs)
	if (locale === "zh-CN") return zh_cn2_shortcut_keys_desc_shift_event_backward(inputs)
	if (locale === "ja") return ja_shortcut_keys_desc_shift_event_backward(inputs)
	if (locale === "hi") return hi_shortcut_keys_desc_shift_event_backward(inputs)
	if (locale === "pt-PT") return pt_pt2_shortcut_keys_desc_shift_event_backward(inputs)
	return en_shortcut_keys_desc_shift_event_backward(inputs)
});